// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { CloseIcon } from "src/assets/icons";

type ExamCardHeaderType = {
  label: string;
  isNew?: boolean;
  onRemoveCard?: () => void;
};

const ExamCardHeader = ({ label, isNew, onRemoveCard }: ExamCardHeaderType) => {
  const { t } = useTranslation();

  return (
    <Grid
      item
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      height="24px"
      width="100%"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          width: "100%",
        }}
      >
        {Boolean(isNew) && (
          <Tooltip
            title={
              <div style={{ whiteSpace: "pre-line" }}>
                {`${t("New test - Pilot Version")}\n${t("Try it out and let us know what you think!")}`}
              </div>
            }
          >
            <Typography
              sx={{
                color: "#22BE39",
                fontSize: "14px",
                fontWeight: 600,
                border: "1px solid #22BE39",
                borderRadius: "4px",
                p: "0px 4px",
              }}
            >
              {t("New")}
            </Typography>
          </Tooltip>
        )}
        <Typography
          sx={{
            fontSize: "14px",
            color: "#FFF",
            fontWeight: 600,
            maxWidth: "80%",
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {t(label)}
        </Typography>
      </Box>
      {onRemoveCard && (
        <IconButton
          aria-label={`remove-${label}-card`}
          onClick={onRemoveCard}
          sx={{
            p: 0,
            color: "#FFF",
          }}
        >
          <CloseIcon height="20px" width="20px" />
        </IconButton>
      )}
    </Grid>
  );
};

export default ExamCardHeader;
